/**
 * Закупщицкий per-user статус позиции.
 *
 * Параллельная шкала к глобальному `RequestItemStatus` (менеджерский цикл).
 * Каждый закупщик (и РОЗ) имеет СВОЮ запись для позиции: разные
 * закупщики могут быть в разных точках воронки по одной и той же позиции.
 */
export const RequestItemProcurementState = {
  NEW: 'NEW',
  REQUESTED: 'REQUESTED',
  WAITING: 'WAITING',
  NEEDS_INFO: 'NEEDS_INFO',
  QUOTED: 'QUOTED',
  NOT_FOUND: 'NOT_FOUND',
  NO_RESPONSE: 'NO_RESPONSE',
  REFUSED: 'REFUSED',
} as const

export type RequestItemProcurementState =
  (typeof RequestItemProcurementState)[keyof typeof RequestItemProcurementState]

/** Русская подпись для UI. */
export const PROCUREMENT_STATE_LABELS: Record<RequestItemProcurementState, string> = {
  NEW: 'Новая',
  REQUESTED: 'Запрос отправлен',
  WAITING: 'Жду ответа',
  NEEDS_INFO: 'Нужна инфо',
  QUOTED: 'Квота дана',
  NOT_FOUND: 'Не найдено',
  NO_RESPONSE: 'Поставщик не ответил',
  REFUSED: 'Отказ',
}

/** Статусы, которые закупщик может выставить вручную (без автопереходов). */
export const PROCUREMENT_STATE_MANUAL: RequestItemProcurementState[] = [
  'WAITING',
  'NEEDS_INFO',
  'NO_RESPONSE',
  'REFUSED',
]

/** Активные состояния для KPI «в работе». QUOTED не считается — уже готово. */
export const PROCUREMENT_STATE_ACTIVE: RequestItemProcurementState[] = [
  'NEW',
  'REQUESTED',
  'WAITING',
  'NEEDS_INFO',
]

/**
 * Состояния, показывающие что закупщик уже принял решение по позиции
 * («обработана»). NOT_FOUND — квота пришла с ценой 0 (поставщик есть, но
 * предложить нечего): закупщик отработал, позиция считается обработанной.
 */
export const PROCUREMENT_STATE_FINAL: RequestItemProcurementState[] = [
  'QUOTED',
  'NOT_FOUND',
  'NO_RESPONSE',
  'REFUSED',
]

/**
 * Заметки квот-«заготовок». При скачивании BOM-файла поставщику для каждой
 * позиции создаётся квота без цены с заметкой QUOTE_NOTE_REQUEST_SENT.
 * Если поставщик ответил «цена 0» (позиции нет) — квота получает цену 0 и
 * заметку QUOTE_NOTE_NOT_FOUND.
 */
export const QUOTE_NOTE_REQUEST_SENT = 'Запрос поставщику отправлен'
export const QUOTE_NOTE_NOT_FOUND = 'Позиция отсутствует'

/**
 * Пороговые окна очереди закупки — ЕДИНЫЕ для KPI-карточек дашборда закупщика
 * и фильтров «Горящие»/«Без движения» в очереди квот (02.07.2026): раньше
 * карточка «Горящих» считала по одному критерию (HIGH-приоритет ИЛИ дедлайн в
 * ближайшие N дней), а клик вёл на фильтр «Просрочено» (дедлайн в прошлом) —
 * множества не пересекались и очередь показывала пусто.
 */
export const QUEUE_BURNING_DEADLINE_DAYS = 3
export const QUEUE_STALE_DAYS = 5
